module.exports = __webpack_public_path__ + "media/src/images/check-bc7d2555ecc6d670e4a080f872b0064d.svg";